// import { ssDialogService } from '../../../../../services';

export default function ActiveAgendaController(
  $filter,
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  editAgendaDialog,
  loaderService,
  markAuditCompleteConfirmDialog,
  orgDataService,
  ssDialogService,
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.isCategoryInformationExpanded = false;
  vm.isItemInformationExpanded = false;

  vm.canEditItem = vm.agenda.canEdit && vm.agenda.isActive;
  vm.canDeleteItem = vm.agenda.canDelete && vm.agenda.isActive;
  vm.canGenerateItemPackage = vm.agenda.canGeneratePackage && vm.agenda.isActive;
  vm.canDownloadItemPackage = vm.agenda.canDownloadPackage && vm.agenda.hasAgendaPackages;
  vm.canChangeItemStatus = vm.agenda.canChangeStatus && vm.agenda.isActive;

  vm.handleExpandAgenda = handleExpandAgenda;
  vm.handleExpandCategoryInformation = handleExpandCategoryInformation;
  vm.handleExpandItemInformation = handleExpandItemInformation;
  vm.handleExpandSubItemInformation = handleExpandSubItemInformation;
  vm.handleEdit = handleEdit;
  vm.handleDelete = handleDelete;
  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;
  vm.handleMarkStatusComplete = handleMarkStatusComplete;

  vm.handleConfirmDelete = handleConfirmDelete;
  vm.handleCancelDelete = closeDeleteDialog;

  _initEventListeners();

  /** *********************************************
   * Event Handlers
   */

  function handleExpandAgenda(agendaId) {
    vm.isExpanded = !vm.isExpanded;
    if (vm.isExpanded === true) {
      loaderService.showViewLoader = true;
      return oversightSharedModelService.getAgendaCategories(agendaId)
        .then((getCategoryResponse) => {
          loaderService.showViewLoader = false;
          vm.agenda.Categories = getCategoryResponse;
        });
    }

    return false;
  }

  function handleExpandCategoryInformation(category) {
    category.isCategoryInformationExpanded = !category.isCategoryInformationExpanded;
    loaderService.showViewLoader = true;
    if (category.isCategoryInformationExpanded === true) {
      return oversightSharedModelService.getAgendaCategoryItems(category.agendaCategoryId, false)
        .then((getCategoryResponse) => {
          loaderService.showViewLoader = false;
          category.items = getCategoryResponse;
        });
    }

    return false;
  }

  function handleExpandItemInformation(item) {
    item.isItemInformationExpanded = !item.isItemInformationExpanded;
    loaderService.showViewLoader = true;
    if (item.isItemInformationExpanded === true) {
      return oversightSharedModelService.getAgendaCategorySubItems(item.itemId)
        .then((getItemsResponse) => {
          loaderService.showViewLoader = false;
          item.subItems = getItemsResponse;
        });
    }

    return false;
  }

  function handleExpandSubItemInformation(subItem) {
    subItem.isItemInformationExpanded = !subItem.isItemInformationExpanded;
  }

  function handleEdit($event) {
    loaderService.showViewLoader = true;
    return oversightDataService.getAgendaTypes()
      .then(getDataTypesResponse => oversightDataService.getAgenda(vm.agenda.agendaId)
        .then((getAgendaResponse) => {
          loaderService.showViewLoader = false;
          return _showEditAgendaDialog($event, {
            agenda: getAgendaResponse.data,
            agendaTypes: getDataTypesResponse.data.result,
            coordinators: oversightSharedModelService.coordinators,
            refreshAudit: true,
          });
        }));
  }

  function handleDelete($event) {
    return _showDeleteDialog($event, {
      dialogTitle: 'Delete Active Agenda?',
      message: `Are you sure you want to delete agenda "${vm.agenda.name}"?`,
      handleYesClick: handleConfirmDelete,
      handleNoClick: closeDeleteDialog,
    });
  }

  function handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return oversightDataService.deleteAgenda(vm.agenda.agendaId)
      .then(() => {
        alerts.success('The agenda has been deleted successfully.');
        $rootScope.$broadcast('refreshAgendas');
        return closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting agenda.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.oversight.deleteActiveAgendaConfirmDialog);
  }

  function _handleGeneratePackage() {
    return oversightDataService.createAgendaPackageFileGenerationRequest(vm.agenda.agendaId).then(() => {
      alerts.success('The Agenda Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    oversightDataService.downloadPackage(vm.agenda.agendaId).then((packageResponse) => {
      oversightDataService.download(packageResponse);
    });
  }

  function handleMarkStatusComplete() {
    loaderService.showViewLoader = true;
    oversightDataService.completeCheckpoint(vm.agenda.agendaId).then(() => {
      alerts.success('The Agenda has been successfully completed. '
        + 'You will receive an email notification when the agenda is complete.');
      loaderService.showViewLoader = true;
      $rootScope.$broadcast('refreshAgenda', { agendaId: vm.agenda.agendaId });
    });
  }
  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('refreshAgenda', (event, opt) => {
      if (opt.agendaId === vm.agenda.agendaId) {
        oversightDataService.getAgenda(opt.agendaId).then((getAgendaResponse) => {
          vm.agenda = getAgendaResponse.data.result;
        });
      }
    });
  }

  function _showDeleteDialog($event, locals) {
    ssDialogService.dialogs.oversight.deleteActiveAgendaConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.oversight.deleteActiveAgendaConfirmDialog);
  }

  function _showEditAgendaDialog($event, locals) {
    ssDialogService.dialogs.oversight.editAgendaDialog = ssDialogService.alert(
      editAgendaDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.oversight.editAgendaDialog);
  }
}

ActiveAgendaController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'confirmDialog',
  'editAgendaDialog',
  'loaderService',
  'markAuditCompleteConfirmDialog',
  'orgDataService',
  'ssDialogService',
];
